import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab1 from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import axios from "axios";
import Card from "../../../components/Card";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Nav,
  Tab,
  OverlayTrigger,
  Tooltip,
  Button,
  Form,
  Modal,
  Carousel as CarouselN,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ReactFsLightbox from "fslightbox-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import EventTab from "../EventTab";
import Group from "../../dashboard/app/groups";
import Connections from "../app/Connections";
import CatergoryGrid from "../store/store-category-grid";
import AboutTab from "./aboutTab";
import MarketTab from "./marketTab";
import PhotoTab from "./photoTab";
import { AiOutlineDelete } from "react-icons/ai";
import { useProjectName } from "../../../Context/ProjectNameContext";
import MyPostWith from "../MyPostWith";
import { getToken } from "../../../utils/auth";
import { useTranslation } from "react-i18next";

const FsLightbox = ReactFsLightbox.default
  ? ReactFsLightbox.default
  : ReactFsLightbox;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py:3}}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({ userUid }) {
    const { t, i18n } = useTranslation();
  
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [userid, setUserid] = useState("");
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user details fetched successfully user", response?.data?.data);
      setUserData(response?.data?.data);
      setUserid(response?.data?.data._id);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [userid]);
  //    const {userid} = useParams();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleShowDelete = (postid) => {
    setDeleteID(postid);
    setShowDelete(true);
  };
  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/post/all?page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Post Fetched Successfully", response.data.data.allPosts);
      // setPost(response.data.data.allPosts);
      // setHasMore(response.data.data.allPosts.length > 0);
      if (updateData) {
        setPost(response.data.data.allPosts);
      } else {
        setPost((prevPost) => [...prevPost, ...response.data.data.allPosts]);
      }
      setHasMore(response.data.data.noOfEntries > 0);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };

  useEffect(() => {
    if (page === 1) {
      handleAllPost(true);
    } else {
      handleAllPost();
    }
  }, [page, userid]);
  const [deleteID, setDeleteID] = useState("");

  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });
  const [userDetail, setUserDetail] = useState("");
  const handleUserDetail = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/scan-profile/${userid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("User Detail fetched successfully", response.data.data);
      setUserDetail(response.data.data);
    } catch (error) {
      console.log("Failed Fetching User Detail", error);
    }
  };

  useEffect(() => {
    handleUserDetail();
  }, [userid]);

  const handleSendRequest = async () => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/connection/sent-request`,
        {
          requestTo: userid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed Sending Friend Request", error);
    }
  };

  const handleSavePost = async (postID) => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/save/${postID}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed Saving Post");
      console.log("Failed Saving Posts", error);
    }
  };

  function imageOnSlide(number) {
    setImageController({
      toggler: !imageController.toggler,
      slide: number,
    });
  }
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportId, setReportId] = useState("");
  const handleReportClick = (reqid) => {
    setReportId(reqid);
    setReportModalOpen(true);
  };

  const closeReportModal = () => {
    setReportModalOpen(false);
  };
  const handleReport = async () => {
    if (!reportDescription) {
      toast.info("Report issue is required");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/report`,
        {
          reportFor: "post",
          issueDescription: reportDescription,
          userId: "",
          postId: reportId,
          eventId: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeReportModal();
      setReportId("");
      setReportDescription("");
      toast.success(response.data.message);
    } catch (error) {
      setReportId("");
      setReportDescription("");
      toast.error(error?.response?.data?.message || "Failed Reporting Post");
      console.log("Failed SaviReportingng Posts", error);
    }
  };

  const [connection, setConnection] = useState([]);

  const handleConnections = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Connections Fetched Successfully");
      setConnection(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };
  useEffect(() => {
    handleConnections();
  }, []);


  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const handleFileInputChange = (event) => {
    setSelectedFile([...event.target.files]);
    toast.success("File selected!");
  };
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };

  const [photos, setPhotos] = useState([]);
  const handlePost = async () => {
    if (!description) {
      toast.info("Description is required");
      return;
    }
    try {
      const token = getToken();
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("files", selectedFile[i]);
      }

      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("oath", uploadResponse.data.data);

      setPhotos(uploadResponse.data.data);
      postPhoto(uploadResponse.data.data);

      //   setShow(false);
    } catch (error) {
      console.log("Failed to create post:", error);
      toast.error(
        error?.uploadResponse?.data?.message || "Failed to Upload Image/Video"
      );
    }
  };

  const postPhoto = async (photoss) => {
    if (!description) {
      toast.info("Description is required");
      return;
    }
    try {
      const token = getToken();
      const postData = {
        description: description,
        photos: photoss,
        postType: categorypost,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleAllPost(true);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      //   setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    } finally {
      setShow(false);
    }
  };
  const [userDetailSocial, setUserDetailSocial] = useState("");
  const handleUserDetailSocial = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("User Detail fetched successfully social", response.data.data.userData);
      let detail = response.data.data.userData;
      setEditForm({
        userBio: detail?.userProfileData?.userBio,
        city: detail?.userProfileData?.address?.city,
        country: detail?.userProfileData?.address?.country,
        birthday: detail?.userProfileData?.birthday,
      });
      setUserDetailSocial(detail);
    } catch (error) {
      console.log("Failed Fetching User Detail", error);
    }
  };

  useEffect(() => {
    handleUserDetailSocial();
  }, [value]);

  const [profileInfo, setProfileInfo] = useState(true);
  const [edit, setEdit] = useState(false);
  const [editForm, setEditForm] = useState({
    userBio: "",
    city: "",
    country: "",
    birthday: "",
  });
  const openEdit = () => {
    setProfileInfo(false);
    setEdit(true);
  };

  const handleSave = async () => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        editForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleUserDetailSocial();
      setProfileInfo(true);
      setEdit(false);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  const handleEditFormChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const [showGroupPopup, setShowGroupPopup] = useState(false);
  const [postidDetail, setPostidDetail] = useState("");
  const handleCloseGroupPopup = () => setShowGroupPopup(false);

  const handleShowGroupPopup = (postid) => {
    setPostidDetail(postid);
    setShowGroupPopup(true);
  };
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [groups, setGroups] = useState([]);

  const handleAllGroups = async () => {
    try {
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/group/all?searchfor=my`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      // console.log("Group Fetched Successfully");
      setGroups(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Group", error);
    }
  };

  useEffect(() => {
    handleAllGroups();
  }, []);

  const handleGroupSelection = (e) => {
    const value = e.target.value;
    setSelectedGroups((prev) =>
      prev.includes(value)
        ? prev.filter((group) => group !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = async () => {
    if (!postidDetail) {
      toast.info("Please try later");
      return;
    }
    const payload = {
      postId: postidDetail,
      groupIds: selectedGroups,
    };
    const token = getToken();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/share`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.message);
      setSelectedGroups([]);
      handleCloseGroupPopup();
    } catch (error) {
      toast.error("Error sharing post");
      console.log("Share request failed", error);
    }
  };

  const handleCopyUrl = (postId) => {
    const url = `${process.env.REACT_APP_URL_POST}/post/${postId}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        //   alert('URL copied to clipboard');
        toast.success("URL Copied");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  };
  const projectName = useProjectName();
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab1 label={t("qr_hero")} {...a11yProps(0)} />
            <Tab1 label={t("posts")} {...a11yProps(1)} />
            <Tab1 label={t("photos")} {...a11yProps(2)} />
            <Tab1 label={t("about")} {...a11yProps(2)} />
            <Tab1 label={t("marketPlace")} {...a11yProps(2)} />
            <Tab1 label={t("connections")} {...a11yProps(2)} />
            <Tab1 label={t("groups")} {...a11yProps(2)} />
            <Tab1 label={t("events")} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          {/* QR Code */}
          <CatergoryGrid />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <Row>
            <Col lg={4}>
              <Card>
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t("profileIntro")}</h4>
                  </div>
                  {profileInfo && (
                    <div className="header-title">
                      <Link
                        onClick={openEdit}
                        className="material-symbols-outlined"
                      >
                        edit
                      </Link>
                    </div>
                  )}
                  {edit && (
                    <div className="header-title">
                      <button
                        style={{ width: "100px" }}
                        className="btn btn-primary d-block "
                        onClick={handleSave}
                      >
                        {t("save")}
                      </button>
                    </div>
                  )}
                </div>
                <Card.Body>
                  <div className="ui-block-content">
                    {profileInfo && (
                      <ul className="list-unstyled ">
                        {userDetailSocial?.userProfileData?.userBio ||
                        userDetailSocial?.userProfileData?.address?.city ||
                        userDetailSocial?.userProfileData?.address?.country ||
                        userDetailSocial?.userProfileData?.birthday ? (
                          <div>
                            <div className="text">
                              <li className="mb-1">
                                <h6 className="title">{t("aboutMe")}:</h6>
                                <span className="text">
                                  {userDetailSocial?.userProfileData?.userBio}
                                </span>
                              </li>
                            </div>
                            <div className="text">
                              <li className="mb-1">
                                <h6 className="title">{t("city")}:</h6>
                                <span className="text">
                                  {
                                    userDetailSocial?.userProfileData?.address
                                      ?.city
                                  }
                                </span>
                              </li>
                            </div>
                            <div className="text">
                              <li className="mb-1">
                                <h6 className="title">{t("country")}:</h6>
                                <span className="text">
                                  {
                                    userDetailSocial?.userProfileData?.address
                                      ?.country
                                  }
                                </span>
                              </li>
                            </div>
                            <div className="text">
                              <li className="mb-1">
                                <h6 className="title">{t("birthday")}:</h6>
                                <span className="text">
                                  {moment(
                                    userDetailSocial?.userProfileData?.birthday
                                  ).format("DD-MM-YYYY")}
                                </span>
                              </li>
                            </div>
                          </div>
                        ) : (
                          <span className="text">
                            {t("pleaseAddProfileInfo")}...
                          </span>
                        )}
                      </ul>
                    )}
                    {edit && (
                      <ul className="list-unstyled ">
                        <span className="text">
                          <li className="mb-4">
                            {/* <h6 className="title">About Me:</h6> */}

                            <Form.Label>{t("userBio")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="userBio"
                              className="mb-0 py-2"
                              id=""
                              placeholder="Enter bio.."
                              value={editForm.userBio}
                              onChange={(e) => {
                                handleEditFormChange(e);
                              }}
                            />

                            <Form.Label>{t("city")} </Form.Label>
                            <Form.Control
                              type="text"
                              name="city"
                              className="mb-0 py-2"
                              id=""
                              placeholder="Enter city.."
                              value={editForm.city}
                              onChange={(e) => {
                                handleEditFormChange(e);
                              }}
                            />
                            <Form.Label>{t("country")} </Form.Label>
                            <Form.Control
                              type="text"
                              name="country"
                              className="mb-0 py-2"
                              id=""
                              placeholder="Enter country.."
                              value={editForm.country}
                              onChange={(e) => {
                                handleEditFormChange(e);
                              }}
                            />
                            <Form.Label>{t("birthday")} </Form.Label>
                            <Form.Control
                              type="date"
                              name="birthday"
                              className="mb-0 py-2"
                              id=""
                              placeholder="Enter birthday.."
                              value={moment(editForm.birthday).format(
                                "YYYY-MM-DD"
                              )}
                              onChange={(e) => {
                                handleEditFormChange(e);
                              }}
                            />
                          </li>
                        </span>
                      </ul>
                    )}

                    {/* <li className="mb-4">
                                  <h6 className="title">Favourite TV Shows:</h6>
                                  <span className="text">
                                    Breaking Good, RedDevil, People of Interest,
                                    The Running Dead, Found, American Guy.
                                  </span>
                                </li> */}
                    {/* <li className="mb-4">
                                  <h6 className="title">
                                    Favourite Music Bands / Artists:
                                  </h6>
                                  <span className="text">
                                    Iron Maid, DC/AC, Megablow, The Ill, Kung
                                    Fighters, System of a Revenge.
                                  </span>
                                </li> */}
                    {/* </ul> */}
                    {/* <div className="widget w-socials">
                                <h6 className="title mb-3">
                                  Other Social Networks:
                                </h6>
                                <Link
                                  to="#"
                                  className="social-item btn btn-primary d-flex align-items-center justify-content-center"
                                >
                                  <svg
                                    className="me-1"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <title>facebook1</title>
                                    <path d="M17 3v2h-2c-0.552 0-1.053 0.225-1.414 0.586s-0.586 0.862-0.586 1.414v3c0 0.552 0.448 1 1 1h2.719l-0.5 2h-2.219c-0.552 0-1 0.448-1 1v7h-2v-7c0-0.552-0.448-1-1-1h-2v-2h2c0.552 0 1-0.448 1-1v-3c0-1.105 0.447-2.103 1.172-2.828s1.723-1.172 2.828-1.172zM18 1h-3c-1.657 0-3.158 0.673-4.243 1.757s-1.757 2.586-1.757 4.243v2h-2c-0.552 0-1 0.448-1 1v4c0 0.552 0.448 1 1 1h2v7c0 0.552 0.448 1 1 1h4c0.552 0 1-0.448 1-1v-7h2c0.466 0 0.858-0.319 0.97-0.757l1-4c0.134-0.536-0.192-1.079-0.728-1.213-0.083-0.021-0.167-0.031-0.242-0.030h-3v-2h3c0.552 0 1-0.448 1-1v-4c0-0.552-0.448-1-1-1z"></path>
                                  </svg>
                                  Facebook
                                </Link>
                                <Link
                                  to="#"
                                  className="social-item btn btn-info d-flex align-items-center justify-content-center"
                                >
                                  <svg
                                    className="me-1"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <title>twitter</title>
                                    <path d="M20.833 5.262c-0.186 0.242-0.391 0.475-0.616 0.696-0.233 0.232-0.347 0.567-0.278 0.908 0.037 0.182 0.060 0.404 0.061 0.634 0 5.256-2.429 8.971-5.81 10.898-2.647 1.509-5.938 1.955-9.222 1.12 1.245-0.361 2.46-0.921 3.593-1.69 0.147-0.099 0.273-0.243 0.352-0.421 0.224-0.505-0.003-1.096-0.508-1.32-2.774-1.233-4.13-2.931-4.769-4.593-0.417-1.084-0.546-2.198-0.52-3.227 0.021-0.811 0.138-1.56 0.278-2.182 0.394 0.343 0.803 0.706 1.235 1.038 2.051 1.577 4.624 2.479 7.395 2.407 0.543-0.015 0.976-0.457 0.976-1v-1.011c-0.002-0.179 0.009-0.357 0.034-0.533 0.113-0.806 0.504-1.569 1.162-2.141 0.725-0.631 1.636-0.908 2.526-0.846s1.753 0.463 2.384 1.188c0.252 0.286 0.649 0.416 1.033 0.304 0.231-0.067 0.463-0.143 0.695-0.228zM22.424 2.183c-0.74 0.522-1.523 0.926-2.287 1.205-0.931-0.836-2.091-1.302-3.276-1.385-1.398-0.097-2.836 0.339-3.977 1.332-1.036 0.901-1.652 2.108-1.83 3.372-0.037 0.265-0.055 0.532-0.054 0.8-1.922-0.142-3.693-0.85-5.15-1.97-0.775-0.596-1.462-1.309-2.034-2.116-0.32-0.45-0.944-0.557-1.394-0.237-0.154 0.109-0.267 0.253-0.335 0.409 0 0-0.132 0.299-0.285 0.76-0.112 0.337-0.241 0.775-0.357 1.29-0.163 0.722-0.302 1.602-0.326 2.571-0.031 1.227 0.12 2.612 0.652 3.996 0.683 1.775 1.966 3.478 4.147 4.823-1.569 0.726-3.245 1.039-4.873 0.967-0.552-0.024-1.019 0.403-1.043 0.955-0.017 0.389 0.19 0.736 0.513 0.918 4.905 2.725 10.426 2.678 14.666 0.261 4.040-2.301 6.819-6.7 6.819-12.634-0.001-0.167-0.008-0.33-0.023-0.489 1.006-1.115 1.676-2.429 1.996-3.781 0.127-0.537-0.206-1.076-0.743-1.203-0.29-0.069-0.58-0.003-0.807 0.156z"></path>
                                  </svg>
                                  Twitter
                                </Link>
                                <Link
                                  to="#"
                                  className="social-item btn btn-danger d-flex align-items-center justify-content-center"
                                >
                                  <svg
                                    className="me-1"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="currentColor"
                                  >
                                    <title>dribbble</title>
                                    <path d="M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z"></path>
                                  </svg>
                                  Dribbble
                                </Link>
                              </div> */}
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={8}>
              <MyPostWith />
            </Col>
          </Row>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          {/* Photos */}
          <PhotoTab userUid={userUid} />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={3}>
          {/* About */}
          <Card className="p-2">
            <AboutTab />
          </Card>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={4}>
          {/* Market Place */}
          <Card className="p-2">
            <MarketTab />
          </Card>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={5}>
          <Connections />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={6}>
          <Group  />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={7}>
          <EventTab />
        </CustomTabPanel>
      </Box>
    </>
  );
}
